import icon1 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_01.svg';
import icon2 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_02.svg';
import LandingSection from 'components/landing/components/landing-section';
import TextBox from 'core/text-box';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';

const Concept = () => {
    const { seoText, verification } = useGetSeoTextByIndex('home_concept');

    if (!verification) {
        return null;
    };

    return (
        <LandingSection>
            <div className="paragraph_wrapper" style={{ marginBottom: '40px', gap: '50px' }}>
                <TextBox
                    title={seoText.column1.title}
                    content={`${seoText.column1.paragraph1.sentence1} \n \n ${seoText.column1.paragraph2.sentence1}`}
                    image={icon1}
                    imageHeight={71}
                    containerHeight="auto"
                    titleTag="h2"
                />
                <TextBox
                    title={seoText.column2.title}
                    content={`${seoText.column2.paragraph1.sentence1} \n \n ${seoText.column2.paragraph2.sentence1}`}
                    image={icon2}
                    imageHeight={71}
                    containerHeight="auto"
                    titleTag="h2"
                />
            </div>
        </LandingSection>
    );
};

export default Concept;
